var React = require('react');

function PicturePlaceholder (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"fill":"#054FD0","transform":"translate(-21.277 -1.112)","key":1},React.createElement("path",{"d":"M68.57,53.45c0-8.367-6.493-15.354-16.594-16.739V33.718A23.625,23.625,0,0,0,55.9,25.172a1.978,1.978,0,0,0,1.743-1.448,2.678,2.678,0,0,0,.057-.316,4.6,4.6,0,0,0,.84-1.789c.4-1.669-.049-3.274-1.006-3.771l.028-3.725c0-6.923-4.7-13.011-12.636-13.011S32.284,7.2,32.284,14.122l.035,3.725c-.958.5-1.411,2.1-1.014,3.771a4.693,4.693,0,0,0,.846,1.789,2.547,2.547,0,0,0,.054.316,1.977,1.977,0,0,0,1.741,1.448,23.65,23.65,0,0,0,3.926,8.546V36.71c-10.1,1.386-16.6,8.374-16.6,16.739C21.278,53.687,68.57,53.687,68.57,53.45Z"}))]);
}

PicturePlaceholder.defaultProps = {"width":"47.293","height":"52.516","viewBox":"0 0 47.293 52.516"};

module.exports = PicturePlaceholder;

PicturePlaceholder.default = PicturePlaceholder;
